import { NAME_SPACE } from './config';
import heroCarousel from './HeroCarousel.vue';

export default {
    name: NAME_SPACE,
    components: {
        'hero-carousel': heroCarousel,
    },
};
